export class AuctionMainTable {

  constructor() {
    this.status = '';
    this.code = '';
    this.dateSubmission = '';
    this.dateAuction = '';
    this.region = '';
    this.contractor = '';
    this.costAuction = 0;
    this.distributerParticipant = '';
    this.distributerLogistic = '';
    this.distributerWinner = '';
    this.manager = '';
  }

  status: string;
  code: string;
  dateSubmission: string;
  dateAuction: string;
  region: string;
  contractor: string;
  costAuction: number;
  distributerParticipant: string;
  distributerLogistic: string;
  distributerWinner: string;
  manager: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/auction-main-table.ts